<template lang="pug">
v-snackbar(
  bottom
  right
  :timeout='3000'
  color='success'
  @click='$emit(`input`, false)'
  v-model='isShow'
)
  v-icon.mr-2(dark) check
  span {{ content }}
  v-spacer
</template>

<script>
export default {
  name: 'SnackbarSuccess',
  data () {
    return {
      isShow: false,
      content: '成功發佈變更',
    }
  },
  methods: {
    show (_) {
      this.content = _
      this.isShow = true
    },
  },
}
</script>
